<template>
  <div class="">
    <div class="row justify-content-center py-5 einblenden1">
      <div class="col-lg-10 grauHintergrund">
        <!-- Paletten-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPaletten/Euro.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Euro-Paletten</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Europaletten nach EPAL-Standard – aus stabilem Vollholz gefertigt,
                tragfähig und langlebig. Ideal für Transport und Lagerung in Industrie und
                Handel. Mehrwegfähig und weltweit genormt für reibungslosen Warenverkehr.
                Maße: 1200 x 800 mm.
              </div>
              <div class="col-lg-4">
                <span class="input-group-text" style="width: 100%" id="basic-addon1"
                  >Kurze Beschreibung</span
                >
                <div class="input-group mb-3">
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    v-model="eurotext"
                  ></textarea>
                </div></div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="euro" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addItemEuro()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedEu" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Einwegpaletten-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPaletten/KundenPalette.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
            <h2 class="kachelHeader">Einwegpaletten nach Wunschmaß</h2>
                Transportpaletten nach Kundenmaß – individuell gefertigt für Ihre
                Anforderungen. Robuste Bauweise aus hochwertigem Holz oder Kunststoff,
                ideal für Lagerung und sicheren Transport. Geeignet für den Einsatz in
                Logistik, Industrie und Handel.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Auflagefläche:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kundenlaenge"
                    />
                  </div>
                  <div class="input-group mb-3">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kundenbreite"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="kundentext"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="kunden" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addItemKunden()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedKk" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Transportkisten-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPaletten/Kiste.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
            <h2 class="kachelHeader">Transportkisten aus Holz</h2>
                Individuell gefertigt für sicheren Versand und Lagerung. Stabiler Aufbau
                für schwere und empfindliche Güter. Geeignet für nationalen und
                internationalen Transport. Optional mit Deckel, Verschlüssen und
                IPPC-Kennzeichnung erhältlich.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Innenmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kistenlaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kistebreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Höhe in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kistenhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="kistentext"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="kisten" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addItemKiste()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedKi" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { anfragenStore } from "@/stores/AnfrageStore";
export default {
  name: "balkenMitBildPaletten",
  data() {
    return {
      euro: 0,
      eurotext: "",
      kunden: 0,
      kundenbreite: 0,
      kundenlaenge: 0,
      kundentext: "",
      kisten: 0,
      kistebreite: 0,
      kistenlaenge: 0,
      kistenhoehe: 0,
      kistentext: "",
      addedKi: false,
      addedKk: false,
      addedEu: false,
      // bestellStatus: this.$store.state.bestellung.bestellStatus,
      // globalParam: this.$store.state.globalParam,
    };
  },
  // mounted() {
  //   this.updateAuswahl();
  // },

  methods: {
    addItemEuro() {
      let item = {
        name: "Europalette",
        anzahl: this.euro,
        beschreibung: this.eurotext,
      };
      const store = anfragenStore();

      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedEu = true;
      setTimeout(() => {
        this.addedEu = false;
        this.euro = 0;
        this.eurotext = "";
      }, 2000);
    },

    addItemKunden() {
      let item = {
        name: "KundenPalette",
        anzahl: this.kunden,        
        beschreibung: this.kundentext,
        masse: {
          laenge: this.kundenlaenge,
          breite: this.kundenbreite,
        },
      };
      const store = anfragenStore();

      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedKk = true;
      setTimeout(() => {
        this.addedKk = false;
        this.kunden = 0;
        this.kundenlaenge = 0;
        this.kundenbreite = 0;
        this.kundentext = "";
      }, 2000);
    },

    addItemKiste() {
      let item = {
        name: "Kiste",
        anzahl: this.kisten,
        beschreibung: this.kistentext,
        masse: {
          laenge: this.kistenlaenge,
          breite: this.kistebreite,
          hoehe: this.kistenhoehe,
        },
      };
      const store = anfragenStore();

      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedKi = true;
      setTimeout(() => {
        this.addedKi = false;
        this.kisten = 0;
        this.kistenlaenge = 0;
        this.kistebreite = 0;
        this.kistenhoehe = 0;
        this.kistentext = "";
      }, 2000);
    },
  },
};
</script>
